"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.xformFeatureFlags = xformFeatureFlags;
function xformFeatureFlags(flagData) {
  return flagData.reduce((acc, flag) => {
    acc[flag.Name] = flag.Value === 'true';
    return acc;
  }, {});
}